import useApiService from "../../../../hooks/useApiService";
import { DataTable } from "primereact/datatable";
import { SiteEmployee } from "../../../../models/employees.interface";
import { Column } from "primereact/column";
import { AppointmentSetup } from "../../../../models/site-setup.interface";
import { CancelIcon, CheckIcon } from "../../../../assets/icons";
import React, { useState } from "react";
import { Button } from "primereact/button";
import SiteEmployeeAdd from "../../site-employee/Site-Employee-Add";
import { Dialog } from "primereact/dialog";

export function EmployeesPanel() {
  const [modalToShow, setModalToShow] = useState<"add-employee" | null>(null);
  const [selectedRecord, setSelectedRecord] = useState<SiteEmployee | null>(null);
  const {
    data,
    loading,
    fetchData: fetchEmployees,
  } = useApiService<SiteEmployee[]>({
    url: "site-employee",
    method: "GET",
    apiName: "core",
    fetchOnMount: true,
  });

  const renderComplianceStatus = (row: SiteEmployee) => {
    if (row.compliance_status) {
      return <CheckIcon fill={"#2DD36FFF"} />;
    }
    return <CancelIcon fill={"#EB445AFF"} />;
  };

  const renderActiveStatus = (row: SiteEmployee) => {
    if (row.active) {
      return <CheckIcon fill={"#2DD36FFF"} />;
    }
    return <CancelIcon fill={"#EB445AFF"} />;
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", margin: "1rem 0" }}>
        <Button
          label={"Add"}
          icon={"pi pi-plus"}
          className={"p-button-sm p-button-outlined"}
          color={"success"}
          style={{ color: "#2dd36f" }}
          onClick={() => setModalToShow("add-employee")}
        />
      </div>
      <DataTable
        loading={loading}
        value={data ?? []}
        className={`policies-procedures-table`}
        tableStyle={{ minWidth: "50rem" }}
        onRowClick={event => {
          setModalToShow("add-employee");
          setSelectedRecord(event.data as SiteEmployee);
        }}
      >
        <Column header={"Name"} field={"full_name"} style={{ minWidth: "12rem" }} />
        <Column header={"Title"} field={"title"} />
        <Column header={"Appointment"} field={"appointment_list"} style={{ minWidth: "12rem" }} />
        <Column header={"ID Number"} field={"id_number"} />
        <Column
          header={"Compliance status"}
          field={"compliance_status"}
          body={renderComplianceStatus}
        />
        <Column header={"Active"} field={"active"} body={renderActiveStatus} />
      </DataTable>
      <Dialog
        header={selectedRecord?.id ? "Update Employee" : "Add Employee"}
        visible={modalToShow === "add-employee"}
        style={{ width: "50vw" }}
        onHide={() => setModalToShow(null)}
      >
        <SiteEmployeeAdd
          record={selectedRecord}
          callback={() => {
            fetchEmployees();
          }}
          setVisible={(val: boolean) => {
            if (!val) {
              setModalToShow(null);
              setSelectedRecord(null);
            }
          }}
        />
      </Dialog>
    </div>
  );
}
